// address types
export const AddressType = {
    ShippingAddress: 1,
    BillingAddress: 2
}